var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassHid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.6325C14.76 6.6325 17 8.8725 17 11.6325C17 12.1425 16.9 12.6325 16.76 13.0925L19.82 16.1525C21.21 14.9225 22.31 13.3825 23 11.6225C21.27 7.2425 17 4.1325 12 4.1325C10.73 4.1325 9.51 4.3325 8.36 4.7025L10.53 6.8725C11 6.7325 11.49 6.6325 12 6.6325ZM2.71 3.2925C2.32 3.6825 2.32 4.3125 2.71 4.7025L4.68 6.6725C3.06 7.9625 1.77 9.6625 1 11.6325C2.73 16.0225 7 19.1325 12 19.1325C13.52 19.1325 14.97 18.8325 16.31 18.3125L19.03 21.0325C19.42 21.4225 20.05 21.4225 20.44 21.0325C20.83 20.6425 20.83 20.0125 20.44 19.6225L4.13 3.2925C3.74 2.9025 3.1 2.9025 2.71 3.2925ZM12 16.6325C9.24 16.6325 7 14.3925 7 11.6325C7 10.8625 7.18 10.1325 7.49 9.4925L9.06 11.0625C9.03 11.2425 9 11.4325 9 11.6325C9 13.2925 10.34 14.6325 12 14.6325C12.2 14.6325 12.38 14.6025 12.57 14.5625L14.14 16.1325C13.49 16.4525 12.77 16.6325 12 16.6325ZM14.97 11.3025C14.82 9.9025 13.72 8.8125 12.33 8.6625L14.97 11.3025Z",
    fill: "#616161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassHid);
export default __webpack_public_path__ + "static/media/pass-hid.f77d91c1f0a46ad99be033a4e40af03a.svg";
export { ForwardRef as ReactComponent };